import { createApp } from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag';
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@vueform/multiselect/themes/default.css'
import setupInterceptors from './utils/api-interceptor'
import VueAwesomePaginate from "vue-awesome-paginate"
import "vue-awesome-paginate/dist/style.css"

setupInterceptors()
createApp(App).use(router).use(VueAwesomePaginate).use(VueGtag, {config: { id: "G-PTK7BMQP8R" }}).mount('#app')
